// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Chart } from 'sonata-react-components';
import { normalize } from 'sonata-static-storage/lib/helpers/i18nUnits.helpers';

import { getDoohDemographyAges } from '@/store/selectors/reporting.selectors';

const ReportingAgeAndGender: React.VFC = () => {
  const { formatMessage } = useIntl();
  const item = useSelector(getDoohDemographyAges);

  const getAgesSeries = () => {
    return [
      {
        color: '#5d3191',
        data: item.data[0],
        name: formatMessage({
          defaultMessage: 'Male',
          id: 'reporting.ageAndGender.male'
        })
      },
      {
        color: '#c12680',
        data: item.data[1],
        name: formatMessage({
          defaultMessage: 'Female',
          id: 'reporting.ageAndGender.female'
        })
      }
    ];
  };

  const chartConfig = () => ({
    chart: {
      type: 'column'
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        grouping: true,
        shadow: false
      }
    },
    series: getAgesSeries(),
    title: {
      text: formatMessage({
        defaultMessage: 'Gender & age',
        id: 'reporting.ageAndGender.title'
      })
    },
    tooltip: {
      formatter(): string {
        // @ts-ignore
        const number = normalize(this.y, 0);
        // @ts-ignore
        return `${this.series.name}${this.key}: ${number} ${formatMessage({
          defaultMessage: 'Impressions',
          id: 'reporting.metrics.impressions'
        })}`;
      }
    },
    xAxis: [
      {
        categories: item.series.map(seriesKey =>
          formatMessage({
            defaultMessage: seriesKey,
            id: `reporting.ageAndGender.${seriesKey}`
          })
        ),
        labels: {
          rotation: -45,
          style: {
            fontFamily: 'Verdana, sans-serif',
            fontSize: '10px'
          }
        }
      }
    ],
    yAxis: [
      {
        gridLineWidth: 1,
        min: 0,
        tickWidth: 0,
        title: { text: null }
      }
    ]
  });

  return (
    <div className="chartContainer__ages boxPanel">
      <Chart config={chartConfig()} id="reportingDoohAgesAndGenderGraph" yAxis={[]} />
    </div>
  );
};

export default React.memo(ReportingAgeAndGender);
